import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "./ui/alert-dialog";

/**
 * Shown when the user tries to start a timer while one is already running.
 *
 * Props:
 * open – controlled open state
 * onCancel – called when the user dismisses without action
 * onStopAndStart – called when the user confirms "Stop & Start"
 * currentTimer – { work_order_title, description, start_time } from the 409 response
 */
const TimerConflictDialog = ({ open, onCancel, onStopAndStart, currentTimer }) => {
  const runningOn = currentTimer?.work_order_title || "current task";
  const startedAt = currentTimer?.start_time
    ? new Date(currentTimer.start_time).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
    : null;

  return (
    <AlertDialog open={open} onOpenChange={(v) => !v && onCancel()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Timer already running</AlertDialogTitle>
          <AlertDialogDescription>
            You have an active timer on <span className="font-semibold text-brand-ink">{runningOn}</span>
            {startedAt && <> (started {startedAt})</>}.
            Stopping it will log that time entry automatically.
            <br /><br />
            Stop the current timer and start a new one?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel}>Keep running</AlertDialogCancel>
          <AlertDialogAction
            onClick={onStopAndStart}
            className="bg-orange-600 hover:bg-orange-700 text-white"
          >
            Stop &amp; Start new
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default TimerConflictDialog;
